
import { TranslationObject } from '@/types/language';

const hebrewTranslations: TranslationObject = {
  // Home Screen
  'welcome': 'ברוך הבא למוזיאון',
  'select_tour': 'בחר סיור',
  'search_exhibit': 'חפש מוצג',
  'visitor_info': 'מידע למבקרים',
  
  // Tour Selection
  'available_tours': 'לחצו לבחירת סיור',
  'view_all_tours': 'הצג את כל הסיורים',
  
  // Exhibit Access
  'exhibit_access': 'גישה למוצגים',
  'enter_number': 'הקש מספר מוצג',
  'enter_exhibit_number': 'הקישו את מספר התחנה',
  'scan_qr': 'סרוק קוד QR',
  'view_map': 'הצג במפה',
  'browse_exhibits': 'עיון במוצגים',
  'keypad': 'מקלדת',
  'browse_tours': 'עיון בסיורים',
  
  // Exhibit Detail
  'add_to_favorites': 'הוסף למועדפים',
  'remove_from_favorites': 'הסר מהמועדפים',
  'share': 'שתף',
  'previous': 'הקודם',
  'next': 'הבא',
  'audio_guide': 'מדריך שמע',
  'more_info': 'מידע נוסף',
  
  // Favorites
  'favorites': 'מועדפים',
  'no_favorites': 'אין מועדפים עדיין. הוסף מוצגים בזמן הסיור!',
  
  // Visitor Info
  'opening_hours': 'שעות פתיחה',
  'getting_here': 'איך להגיע',
  'contact': 'צור קשר',
  'important_links': 'קישורים חשובים',
  
  // Accessibility
  'accessibility': 'נגישות',
  'font_size': 'גודל גופן',
  'font_size_normal': 'רגיל',
  'font_size_large': 'גדול',
  'font_size_extra_large': 'גדול מאוד',
  'high_contrast': 'ניגודיות גבוהה',
  'language': 'שפה',
  'select_language': 'בחר שפה',
  'accessibility_menu': 'אפשרויות נגישות',
  'toggle_high_contrast': 'הפעל/כבה מצב ניגודיות גבוהה',
  'audio_controls': 'בקרי שמע',
  'playback_speed': 'מהירות הקשבה',
  'volume': 'עוצמת קול',
  'auto_play_audio': 'הפעלה אוטומטית של שמע',
  'toggle_auto_play': 'הפעל/כבה הפעלה אוטומטית',
  
  // Navigation
  'home': 'בית',
  'tours': 'סיורים',
  'exhibits': 'מוצגים',
  'info': 'מידע',
  'map': 'מפה',
  'list': 'רשימה',
  
  // General
  'loading': 'טוען...',
  'error': 'משהו השתבש',
  'back': 'חזור',
  'play': 'נגן',
  'pause': 'השהה',
  'enter_number_button': 'הזן מספר',
  'searching': 'מחפש...',
  
  // Search related translations
  'search': 'חיפוש...',
  'no_results': 'לא נמצאו תוצאות',
  
  // Error Messages
  'no_exhibit_found_with_number': 'לא נמצא מוצג במספר:',
  'unexpected_error': 'אירעה שגיאה בלתי צפויה',
};

export default hebrewTranslations;
